// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"rS","reco":"sS","products":"tS"};